





























































// https://swiperjs.com/swiper-api

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "SliderBlock",

  data: function () {
    return {
      sliders: this.extras.items,

      swiperOptions: {
        speed: 3000,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 60,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        loop: true,
        loopedSlides: 1,
        navigation: {
          prevEl: '.swiper-btn-prev',
          nextEl: '.swiper-btn-next'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletElement: "div",
          dynamicMainBullets: 0
        }
      },

      windowWidth: null,
    };
  },

  mounted: function () {
    window.addEventListener('resize', this.handleWindowSize)
    this.handleWindowSize()
  },
  unMounted: function () {
    window.removeEventListener('resize', this.handleWindowSize)
  },

  methods: {
    getLinkImage: function (imageId, mobileImage) {
      let sizes = {width: 1500, height: 450};
      let _imageId = imageId

      if (!this.$isServer) {
        const innerWidth = window.innerWidth;

        if (innerWidth < 1200) {
          sizes = {width: 960, height: 300};
        }
        if (innerWidth < 600) {
          sizes = {width: 605, height: 546};
          if (mobileImage && mobileImage !== 0) {
            _imageId = mobileImage
          }
        }
        // if (innerWidth < 400) {
        //   sizes = {width: 400, height: 150};
        //   if (mobileImage && mobileImage !== 0) {
        //     _imageId = mobileImage
        //   }
        // }
      }

      return this.$img(_imageId.toString(), sizes);
    },
    handleWindowSize: function () {
      if (!process.client) {
        return
      }
      this.windowWidth = window.innerWidth
    }
  },
  computed: {
    isMobile: function () {
      return this.windowWidth < 991
    },
    preparedArray: function () {
      return this.isMobile ? this.sliders.filter((item) => item.imageId && item.mobileImageId) : this.sliders;
    }
  }

});
